var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal-task',{attrs:{"format":2,"share-link-id":_vm.shareLinkId,"disabled":"","comment-disabled":""},on:{"closed":_vm.onTaskClosed}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }